import _ from 'lodash';
import config from '../../config';

export default {
    isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
    kFormatter(num) {
        return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)
    },
    defaultCover() {
      return [config.API_URL + '/img/product-fallback.png']
    },
    formatSearchQuery(queries) {
        const stationArray = []
        const cityArray = []
        const trainLineArray = []
        const areaArray = []
        _.forEach(queries, function(value) {
            switch(value.type){
              case 'Station':
                stationArray.push(value.id)
                break;
              case 'City':
                cityArray.push(value.id)
                break;
              case 'TrainLine':
                trainLineArray.push(value.id)
                break;
              case 'Area':
                areaArray.push(value.id)
            }
        });
        const params = {
            station: stationArray.toString(),
            city : cityArray.toString(),
            trainLine : trainLineArray.toString(),
            area: areaArray.toString()
        }
        return params
    },
    isFavorite(id, favorites){
      return favorites && favorites.length > 0 && _.includes(favorites, id) ? true : false
    },
    isContainCity(queries){
        return _.findIndex(queries, function(o) { return o.type == 'City'; }) !== -1 ? true : false
    },
    isContainStation(queries){
        return _.findIndex(queries,function(o){ return o.type == 'Station';}) !== -1 ? true : false
    },
    isContainTrainLine(queries){
      return _.findIndex(queries,function(o){ return o.type == 'TrainLine';}) !== -1 ? true : false
    }
}

